<template>
  <div class="gallery-container" id="gallery-container">
    <!-- <h1 class="title">
      Gallery
    </h1> -->

    <div class="masonry-container columns is-gapless is-centered is-multiline is-flex-mobile" id="masonry-container" v-infinite-scroll="loadMore" infinite-scroll-disabled="itemsLoading" infinite-scroll-distance="-1">

      <div class="column is-4 is-6-mobile" v-for="(image, index) in items" data-aos="fade-up" data-aos-once="true" v-if="index !== 8 || isDesktop">
        <a :href="image.link" target="_blank">
          <div class="focus-image-wrapper">
            <figure class="image square" style="" :style="[{
              'background-image': 'url(' + image.images.standard_resolution.url + ')'
              }]">
            </figure>
          </div>
        </a>
      </div>
    </div>

    <!-- <div class="masonry-container" id="masonry-container" v-masonry transition-duration="0.0s" item-selector=".masonry-item" data-masonry-options="{ 'isFitWidth': true }" v-infinite-scroll="loadMore" infinite-scroll-disabled="itemsLoading" infinite-scroll-distance="-1">

      <div v-masonry-tile class="masonry-item" v-for="(image, index) in items" data-aos="slide-up" data-aos-once="true" data-aos-duration="1000" data-aos-offset="0">
        <a :href="image.link" target="_blank">
          <div class="card">
            <div class="card-image">
              <figure class="image">
                <img :src="parseInstagramImageLink(image.images.standard_resolution.url)" alt="Image">
              </figure>
            </div>
          </div>
        </a>
      </div>
    </div> -->

    <!-- <div class="load-more">
      <div class="button" v-if="!itemsEnded" @click="loadMore()" :class="{ 'is-loading': itemsLoading }"></div>
      <div class="ended" v-if="itemsEnded" data-aos="slide-up" data-aos-once="true" data-aos-duration="1000">browse more at<br class="is-hidden-desktop" />&nbsp;&nbsp;<a  href="https://www.instagram.com/adamlob0/" target="_blank"><i class="fa fa-2x fa-instagram" style="vertical-align:middle;"></i> / ADAMLOBOTV</a></div>
    </div> -->

    <div class="control notification is-danger" v-if="error">
      <button class="delete" @click="error = undefined"></button>
      <p v-html="error">
      </p>
    </div>
  </div>
</template>

<script>
  // import EventBus from '@/controllers/EventBus'
  import Site from '@/apis/Site'
  // import Instafetch from '@/controllers/Instafetch'

  export default {
    name: 'masonry-instagram',
    components: {
    },
    data () {
      return {
        isDesktop: true,
        itemsCache: [],
        items: [],
        itemsLoading: false,
        itemsEnded: false,
        itemsHasNext: false,
        itemsHasNextToken: undefined,
        itemsMax: 9,
        error: undefined
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
      // console.log('created InstagramSection.vue')
    },
    mounted () {
      // console.log('mounted InstagramSection.vue')
      // window.GA('send', 'pageview')

      // on event resize
      this.isDesktop = (window.innerWidth >= 768)
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isDesktop = (event.target.innerWidth >= 768)
      }.bind(this))

      // refresh masonry
      this.refresh()

      // var callbackInstagram = function (data) {
      //   console.log(data)
      // }
      // var fetcher = new Instafetch('15794449.23ef492.b92d5f8be35a469ebfaeceb6b259b3d7')
      // // var fetcher = new Instafetch('23ef492f142645d7892ae61d3697f3a6')
      // fetcher.fetch({
      //   // user: 15794449,
      //   tag: 'adamlobotv',
      //   limit: 88,
      //   callback: callbackInstagram
      //   // params: '9gagBlock'
      // })
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      parseInstagramImageLink (link) {
        var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2')
        return linkOut
      },
      getItems: function (onComplete) {
        this.itemsLoading = true
        Site.instagramUser('5748558782.1677ed0.40f4033451474a879b4a621d646f9a0b', this.itemsHasNextToken)
        .then(data => {
          // console.log('get gallery')
          // console.log(data)
          this.itemsHasNext = data.hasNextPage
          this.itemsHasNextToken = data.maxId
          onComplete(data.items)
          this.itemsLoading = false
        })
        .catch(error => {
          // console.log('invalid get gallery', error)
          this.items = []
          // this.error = error.error
          this.error = error.error
          this.error = 'Unable to load, please kindly visit our Instagram account <a href="https://www.instagram.com/cms" target="_blank">here</a>.'
          this.itemsLoading = false
        })
      },
      refresh: function () {
        this.getItems((items) => {
          if (items && items.length > 0) {
            var limitItems = []
            for (var i = 0; i < this.itemsMax; i++) {
              if (i < items.length) {
                limitItems.push(items[i])
              }
            }
            this.items = limitItems
          } else {
            this.items = []
          }
        })
      },
      loadMore: function () {
        // return if exceed (showcase purpose)
        if (!this.itemsHasNext) {
          this.itemsEnded = true
          this.$emit('onItemsEnded', {})
          return
        }

        if (!this.itemsEnded) {
          this.getItems(function (items) {
            this.items = this.items.concat(items)
            if (this.items.length > this.itemsMax) {
              this.items = this.items.slice(0, this.itemsMax)
              this.itemsEnded = true
              this.$emit('onItemsEnded', {})
            }
          }.bind(this))
        }
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// main gallery

.gallery-container {
  // min-height: 800px;
  margin-top: 2em;
  // padding: 15px;
  // padding-top: 30px;
  // padding-bottom: 80px;
  // padding-right: 0px;

  @media screen and (min-width: $desktop) {
    padding: 0px;
    // padding-top: 30px;
    // padding-bottom: 80px;
  }

  .title {
    padding-left: 0px;

    @media screen and (min-width: $desktop) {
      padding-left: 10px;
    }
  }

  .focus-image-wrapper {
    border-radius: 0px;
    box-shadow: 0 0 0, 0 0 0 0;
    margin: 2px;

    @media screen and (min-width: $desktop) {
      margin: 4px;
    }
  }
}

.lb-image {
  width: auto !important
}

// .masonry-container {
//   margin: 0 auto;
// }
//
// .masonry-item {
//   margin: 0 auto 0 auto;
//   padding: 0px;
//   padding-left: 0px;
//   padding-right: 15px;
//   padding-bottom: 15px;
//   width: 50%;
//
//   @media screen and (min-width: $desktop) {
//     padding-left: 10px;
//     padding-right: 10px;
//   }
//
//   @media screen and (min-width: $tablet) {
//     width: 33.33%;
//   }
//
//   @media screen and (min-width: $desktop) {
//     width: 33.33%;
//   }
//
//   .card {
//     border-radius: 0px;
//     box-shadow: 0 0 0, 0 0 0 0;
//     overflow: hidden;
//
//     .card-header, .card-image {
//       margin: 15px;
//       img {
//         border-radius: 0px;
//         transition: all .3s ease;
//
//         &:hover {
//           transform: scale(1.2);
//         }
//       }
//     }
//
//     .card-content {
//       display: none;
//     }
//   }
// }
//
// .load-more {
//   margin-top: 50px;
//   text-align: center;
//
//   .button, .ended {
//     margin: 0 auto;
//     border: 0px;
//     background-color: transparent;
//     color: #999999;
//
//     a {
//       color: $color-gray;
//
//       &:hover {
//         color: $color-gray-mid;
//       }
//     }
//
//     &.is-loading:after {
//       border-color: #999999;
//       border-right-color: transparent;
//       border-top-color: transparent;
//     }
//   }
// }

</style>



// WEBPACK FOOTER //
// InstagramSection.vue?1e0325de